import { ConstMap } from '@/utils/ConstMap';

export enum SearchType {
  LEXICAL = 0,
  SEMANTIC = 1,
}

export enum SummaryStatus {
  DONE = 0,
  RUNNING = 1,
}

export enum TOPIC_TREND_CATEGORY {
  // RAISING = 1,
  VOLUME = 2,
  NEGATIVE_RATIO = 3,
  REVENUE_IMPACT = 4,
}

export enum TOPIC_TREND_CLIENT {
  ACCOUNT = 1,
  CONTACT,
}

export enum GLOBAL_SEARCH_VIEW {
  FEEDBACK = 'FEEDBACK',
  TOPIC = 'TOPIC',
  ACCOUNT = 1,
  CONTACT = 2,
  AGENT = 3,
  TAG = 4,
  REMARKS = 5,
  DATA_ORIGIN = 6,
  CSAT = 7,
  RATING_SCORE = 8,
  NPS = 9,
  CES = 10,
}

export enum SEARCH_RESULT_STATUS {
  DONE = 0,
  RUNNING = 1,
  RUNNING_MORE = 2,
}

export const defaultGlobalSearchConfig = [
  GLOBAL_SEARCH_VIEW.FEEDBACK,
  GLOBAL_SEARCH_VIEW.TOPIC,
];

export const GlobalSearchViewConfigMap = new ConstMap([
  [
    GLOBAL_SEARCH_VIEW.FEEDBACK,
    {
      name: 'Feedback',
    },
  ],
  [
    GLOBAL_SEARCH_VIEW.TOPIC,
    {
      name: 'Topic',
    },
  ],
  [
    GLOBAL_SEARCH_VIEW.TAG,
    {
      name: 'Tag',
    },
  ],
  [
    GLOBAL_SEARCH_VIEW.ACCOUNT,
    {
      name: 'Account',
    },
  ],
  [
    GLOBAL_SEARCH_VIEW.CONTACT,
    {
      name: 'Contact',
    },
  ],
  [
    GLOBAL_SEARCH_VIEW.AGENT,
    {
      name: 'Agent',
    },
  ],
  [
    GLOBAL_SEARCH_VIEW.REMARKS,
    {
      name: 'Remarks',
    },
  ],
  [
    GLOBAL_SEARCH_VIEW.DATA_ORIGIN,
    {
      name: 'Data Origin',
    },
  ],
  [
    GLOBAL_SEARCH_VIEW.CSAT,
    {
      name: 'CSAT',
    },
  ],
  [
    GLOBAL_SEARCH_VIEW.RATING_SCORE,
    {
      name: 'Rating Score',
    },
  ],
  [
    GLOBAL_SEARCH_VIEW.NPS,
    {
      name: 'NPS',
    },
  ],
  [
    GLOBAL_SEARCH_VIEW.CES,
    {
      name: 'CES',
    },
  ],
]);
